/**
 * @generated SignedSource<<2db5e521c6a905015346df1d2ff4cfe7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionWarningConfigState = "DISABLED" | "ENABLED" | "NOT_APPLICABLE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type ui_softwareReleasesManageWarnings_ManageWarningsModal$data = {
  readonly __id: string;
  readonly id: string;
  readonly project: {
    readonly id: string;
  };
  readonly warningConfig: {
    readonly failingBuild: JiraVersionWarningConfigState;
    readonly openPullRequest: JiraVersionWarningConfigState;
    readonly openReview: JiraVersionWarningConfigState;
    readonly unreviewedCode: JiraVersionWarningConfigState;
  };
  readonly " $fragmentType": "ui_softwareReleasesManageWarnings_ManageWarningsModal";
};
export type ui_softwareReleasesManageWarnings_ManageWarningsModal$key = {
  readonly " $data"?: ui_softwareReleasesManageWarnings_ManageWarningsModal$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_softwareReleasesManageWarnings_ManageWarningsModal">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ui_softwareReleasesManageWarnings_ManageWarningsModal",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "project",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": (v0/*: any*/),
            "action": "THROW",
            "path": "project.id"
          }
        ]
      },
      "action": "THROW",
      "path": "project"
    },
    (v0/*: any*/),
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraVersionWarningConfig",
        "kind": "LinkedField",
        "name": "warningConfig",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "openPullRequest"
            },
            "action": "THROW",
            "path": "warningConfig.openPullRequest"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "openReview"
            },
            "action": "THROW",
            "path": "warningConfig.openReview"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "unreviewedCode"
            },
            "action": "THROW",
            "path": "warningConfig.unreviewedCode"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "failingBuild"
            },
            "action": "THROW",
            "path": "warningConfig.failingBuild"
          }
        ]
      },
      "action": "THROW",
      "path": "warningConfig"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraVersion"
};
})();

(node as any).hash = "e5eb838f9801c770bc5137a984a02776";

export default node;
